import React, { useState, useEffect } from 'react';
import { MainBusiness, MainCommunity, MainPopup, MainProduct, MainSpeciality, MainTitle, MainVisual } from 'components';
import { useNavigate } from 'react-router-dom';

import * as S from './MainStyle';

export function Main({ setRef, langList }) {
  const navigate = useNavigate();

  const [position, setPosition] = useState(0);
  function onScroll() {
    setPosition(window.scrollY);
  }

  useEffect(() => {
    window.addEventListener('scroll', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  return (
    <>
      <MainPopup />
      <MainVisual list={langList.main.visualSlide} />
      <S.Section $mPadding="48px 24px">
        <MainTitle title={langList.main.businessTitle} $padding="0" />
        <MainBusiness list={langList.main.businessContent} navigate={navigate} />
      </S.Section>
      <S.Section $background $tPadding>
        <MainTitle title={langList.main.specialityTitle} />
        <MainSpeciality list={langList.main.specialityContent} navigate={navigate} />
      </S.Section>
      <S.Section $width="100vw" $padding="104px 0">
        <MainTitle title={langList.main.productTitle} />
        {langList.main.productContent && <MainProduct list={langList.main.productContent} navigate={navigate} />}
      </S.Section>
      <S.AniBox $position={position > 3000} $tPosition={position > 2800}>
        <S.Section $mPadding="48px 24px">
          <MainTitle title={langList.main.communityTitle} $padding="0" />
          <MainCommunity list={langList.main.communityContnet} navigate={navigate} />
        </S.Section>
      </S.AniBox>
    </>
  );
}
